import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

const BASE_URL = `${CRM_API_URL}/administration/filial-connection`

function fetchFilials ({ onlyNotConnected } = {}) {
  return axios
    .get(BASE_URL, { params: { onlyNotConnected: onlyNotConnected ? 1 : undefined } })
    .then((res) => res.data.data)
}

function fetchSummary (id) {
  return axios.get(`${BASE_URL}/${id}`).then((res) => res.data.data)
}

// Таблица ждёт items + meta.limit, пагинатор Laravel отдаёт data + meta.per_page
function fetchStaleOrders (id, { page, limit } = {}) {
  return axios
    .get(`${BASE_URL}/${id}/stale-orders`, { params: { page, limit } })
    .then((res) => ({
      items: res.data.data,
      meta: {
        total: res.data.meta.total,
        limit: res.data.meta.per_page,
      },
    }))
}

// Пустой массив (или отсутствие аргумента) отменяет все зависшие заказы филиала;
// непустой — только заказы с этими id
function cancelStaleOrders (id, orderIds = []) {
  return axios
    .post(`${BASE_URL}/${id}/stale-orders/cancel`, { orderIds })
    .then((res) => res.data)
}

function setJupiterSync (id, enabled) {
  return axios.patch(`${BASE_URL}/${id}/jupiter-sync`, { enabled }).then((res) => res.data)
}

function setSnoType (id, snoType) {
  return axios.patch(`${BASE_URL}/${id}/sno-type`, { snoType }).then((res) => res.data)
}

function syncBonuses (id) {
  return axios.post(`${BASE_URL}/${id}/bonuses-sync`).then((res) => res.data)
}

export default {
  fetchFilials,
  fetchSummary,
  fetchStaleOrders,
  cancelStaleOrders,
  setJupiterSync,
  setSnoType,
  syncBonuses,
}
